
/**
 *
 *      Data-driven UI logic for the advanced search page
 *
 *      @author Irina Patrikeeva <irina.i.ipatrikeeva@nasa.gov>
 *
 *      Created on 09/22/2017
 *      Modified on 8/16/2021 by Nhi Cmerek
 */

/**
 * Call Query Manager Web endpoint to get the HTML of the search page to render.
 */
function getAdvancedSearchUI( ) {

    // Set global query if query parameter is passed in the URL
    setQueryFromURL();

    // Set type if type is passed in the URL
    setTypeFromURL();

    // Set filters if filters is passed in the URL
    setFiltersFromURL();

    // Set page if page is passed in the URL
    setPageFromURL();

    // Set global page size if size parameter is passed in the URL
    setPageSizeFromURL();

    // Set global group filter if group parameter is passed in the URL
    setGroupFromURL();

    // Set global nosearch flag if nosearch parameter is passed in the URL
    setNoSearchFlagFromURL();


    // Initialize Advanced search menu
    populateAdvancedSearch( 1 );

    // Call the Query Manager Web endpoints to get partial Search page HTML to render

    // Render search page in parts: current filters, available filters, search results, Wiki results

    if ( App && App.globalState ) {

        if ( App.globalState.nosearch === "true" ) {
            // Do not perform Advanced Search and do not display the results
            saveReferrerIntoGlobal();
        } else {
            // Perform Advanced Search and display results on Advanced Search page
            var query = App.globalState.query;

            // Check if query is defined

            if ( query ) {

                // Get current filters

                displayFiltersMenu( 1 );

                // Get available filters

                displayAggregationsMenu( 1 );

                // Get search results

                displayResultsMenu( 1 );

            }
        }
    }
}

/**
 * Fetch DMR models and populate data type drop-down.
 * @param tryNumber {number} The number of times this function has been called.
 */
function populateAdvancedSearch( tryNumber ) {

    // Call Query Manager Web to get a list of active indices with their display model labels
    var alias =  App.globalState.alias;
    if ( alias ) {

        var url = '/query/web/api/v1/activedatasets/' + alias;

        var pageid = 'content';
        var iconid = 'content-icon-id';
        var iconurl = "/static/images/skeleton-advanced-search.png";
        loadSkeletonImage( pageid, iconid, iconurl );

        // Hide the menu until menu is populated with data
        var searchpage = $('#search-layout');
        if ( searchpage ) {
            searchpage.hide();
        }

        $.ajax({
            url: url,
            data: {},
            dataType: 'html'
        })
            .done( function( data ) {
                // Populate data set drop-down
                initializeAdvancedSearchModels( JSON.parse( data ) );
            })
            .fail( function(  data, textStatus, errorThrown ) {
                console.log("Error: Query Manager Web failed to get active data sets");
                console.log(data);
                console.log(textStatus);
                console.log(errorThrown);
                hideLoadingIcon( iconid );

                if ( searchpage ) {
                    searchpage.show();
                }
                if ( tryNumber <= 5 ) {
                    retry(populateAdvancedSearch(tryNumber + 1), tryNumber + 1, 5);
                }
            } );
    }
}

/**
 * Hide search box in the header
 */
function hideSearchBox() {
    var header,
        searchBox;

    // Hide search bar in the header
    header = $('#edi-header');
    if ( header ) {
        searchBox = header.find('#edi-search-box');
        if ( searchBox ) {
            searchBox.hide();
        }
    }
}

/**
 * Initialize advanced search data type drop-down using models from the Query Manager Web.
 * @param models {Array} Array of data models
 */
function initializeAdvancedSearchModels( models ) {
    var types,
        item,
        model,
        i;

    // collect an array of data type names and their fields once the data type is selected
    types = [];
    if ( models ) {
        for ( i = 0; i < models.length; i++ ) {
            item = {};
            model = models[ i ];
            if ( model ) {
                item.name = model.name;

                // Use short_name property as a model label
                item.label = model.short_name;
                if ( ! item.label ) {
                    // If short_name is undefined, use the top-level "label" property
                    item.label = model.label;
                }

                item.id = model.id;

                if ( item.name && item.label ) {
                    types.push( item );
                }
            }
        }
    }

    // Hide fields before type is selected
    $('.conditional').hide();

    // use models stored globally to fill out fields selection once data type has been selected
    // save UI models fetched from DMR to global store upon selection
    initializeAdvancedSearch( arrayUnique( types.sort( compareByLabel ) ) );
}

/**
 * Compare two data type items by their labels
 * @param a {object} - data type object
 * @param b {object} - data type object
 * @returns {number}
 */
function compareByLabel( a, b ) {
    if ( a && b ) {
        if ( a.label < b.label ) {
            return -1;
        } else if ( a.label > b.label ) {
            return 1;
        }
    }
    return 0;
}

/**
 * Returns an array with all unique elements
 * @param array {Array} - input array
 * @returns {Array}
 */
function arrayUnique(array) {
    var a,
        i,
        j;

    if ( array ) {
        a = array.concat();
        for ( i = 0; i < a.length; i++ ) {
            for ( j = i + 1; j < a.length; j++ ) {
                if ( a[ i ].name === a[ j ].name && a[ i ].label === a[ j ].label ) {
                    j--;
                    a.splice( j, 1 );
                }
            }
        }
    }

    return a;
}
/**
 * Populate Advanced Search data type drop-down
 * @param types {Array} - array of data types
 */
function initializeAdvancedSearch( types ) {

    var s,
        select,
        el,
        type,
        selected,
        name,
        dataType,
        i;

    s = $('div#advanced-search-options');

    if ( App.globalState.query ) {
        $('#search-query').val( cleanInput(decodeURIComponent( App.globalState.query ) ));
    }
    if ( s.length > 0 ) {

        if ( types ) {

            // Dynamically add data types to drop-down

            select = $('#data-type-select');
            if ( select && select.length === 1 ) {
                el = select[ 0 ];

                if ( el && el.options ) {

                    // Add - Select data type - option
                    el.options[ 0 ] = new Option( "- Select Record Type -", null );

                    // Add data types
                    for ( i = 0; i < types.length; i++ ) {
                        type = types[ i ];
                        if ( type ) {
                            el.options[ i + 1 ] = new Option( type.label, type.name );
                        }
                    }
                }

                // Listen for change event to get the UI model fields
                select.change( function() {
                    selected = $( this ).find( "option:selected" );
                    if ( selected ) {
                        name = selected.attr("value");
                        if ( name ) {
                            // hide fields previously selected
                            $('.conditional').hide();

                            // empty previous additional fields
                            $('#additional-conditional').empty();

                            // populate model fields
                            initializeAdvancedSearchFields( name );

                        }
                    }
                });

                // Set data type if it is found in the URL
                dataType = getTypeStringFromURL( Backbone.history.getFragment() );
                if ( dataType ) {
                    select.val( dataType );
                    select.change();
                }
            }

            // Listen for click events to perform ES call
            initializeAdvancedSearchButtons();
        }
    }
}

/**
 * Get model fields drop-down when data type is selected
 * @param type {string} Data type name
 */
function initializeAdvancedSearchFields( type ) {

    var model;

    model = getDataModel( type, false );

    if ( model ) {
        populateModelFields( type, model );
    } else {
        // fetch model, save it and populate field drop-down
        // if the call to DMR fails, display an error view
        getJSONUIModel( type, displayFieldModel( type ), dataNotFound( "Get JSON UI model for type " + type ) );
    }
}

/**
 * Display data type model fields and save the model to the global store
 * @param name {string} Data model name.
 * @returns {Function}
 */
function displayFieldModel( name ) {
    /**
     * Callback that is called when the call to fetch the model from Data Model Registry succeeds
     * @param data {object} - data model JSON object
     * @param textStatus {string} - status of the request
     * @param jqXHR {object} - jQuery XMMLHTTPRequest object
     */
    return function( data, textStatus, jqXHR ) {
        var model = data;
        if ( model ) {
            // save model to global store
            saveDataModel( name, model );
            populateModelFields( name, model );
        }
    };
}

/**
 * Populate model fields drop-down element for the first field
 * @param dataModelName {string} Data model name.
 * @param model {object} JSON data model.
 */
function populateModelFields( dataModelName, model ) {

    var s,
        errorRegion,
        errorRegionId,
        fields,
        sortedFields,
        select,
        el,
        field,
        selected,
        fieldName = '',
        urlType,
        dataType,
        type,
        filters,
        i;

    // remove error region if present
    errorRegionId = "error-region";
    if ( $( '#' + errorRegionId ).length > 0 ) {
        if ( App && App.globalState && App.globalState.layout ) {
            errorRegion = App.globalState.layout.getRegion( errorRegionId );
            if ( errorRegion && $( errorRegion.el ).length > 0 ) {
                App.globalState.layout.getRegion( errorRegionId ).reset();
            }
        }
    }

    s = $('div#advanced-search-options');
    if ( s.length > 0 ) {

        fields = getModelProperties( model );

        if ( fields ) {

            // Dynamically add model fields to fields drop-down

            sortedFields = arrayUnique( fields.sort( compareByLabel ) );

            select = $( '#model-fields' );
            if ( select && select.length === 1 ) {
                el = select[ 0 ];

                if ( el && el.options ) {
                    // Reset available options
                    el.options.length = 0;

                    // Add - Select field - option
                    el.options[ 0 ] = new Option( "- Select field -", null );

                    // Add model fields
                    for ( i = 1; i < sortedFields.length; i++ ) {
                        field = sortedFields[ i - 1 ];
                        if ( field ) {
                            el.options[ i ] = new Option( field.label, field.name );
                        }
                    }

                    // hide previous predicates
                    $('.field-conditional').hide();

                    // Show fields
                    $('.conditional').show();

                }

                // Listen for change event to get the field predicates or properties for nested fields
                select.change( function() {
                    selected = $( this ).find( "option:selected" );
                    if ( selected ) {
                        fieldName = selected.attr("value");
                        if ( fieldName ) {

                            // hide previous field inputs and predicates
                            $('.field-conditional').hide();
                            $('#field-properties').hide();
                            $('#data-date-calendar-2').hide();

                            initializeFieldPredicates( fieldName, model, dataModelName );

                            // remove previously added additional fields
                            $('#additional-conditional').empty();
                        }
                    }
                });

                // compare the type selected
                urlType = getTypeStringFromURL( Backbone.history.getFragment() );
                dataType = $( "#data-type-select" );
                if ( dataType ) {
                    type = dataType.val();
                    if ( type === urlType ) {
                        // Set field filter if it is found in the URL
                        filters = getFiltersStringFromURL( Backbone.history.getFragment() );
                        if ( filters ) {
                            setAdvancedSearchFilters( filters );
                        }
                    }
                }
            }
        }
    }
}

/**
 * Set advanced search filters in the UI based on the filters string
 * @param filters {string} Filters URL string in the form: {fieldName}|{predicate}|{fieldValue};
 */
function setAdvancedSearchFilters( filters ) {

    var dataType,
        model,
        filtersArray,
        filter,
        filterArray,
        fieldName,
        predicate,
        fieldValue,
        type,
        i;

    if ( filters ) {

        // get data model from the global store
        dataType = getTypeStringFromURL( Backbone.history.getFragment() );
        model = getDataModel( dataType, false );

        // parse the filters string
        filtersArray = filters.split(';');
        if ( filtersArray && filtersArray.length > 0 ) {

            for ( i = 0; i < filtersArray.length; i++ ) {
                // Display URL filters in the UI menu
                filter = filtersArray[ i ];

                if ( filter ) {

                    filterArray = filter.split('|');
                    if ( filterArray && filterArray.length === 3 ) {
                        fieldName = filterArray[ 0 ];
                        predicate = filterArray[ 1 ];
                        fieldValue = filterArray[ 2 ];

                        if ( i === 0 ) {
                            setAdvancedSearchFilter( fieldName, predicate, fieldValue, model );
                        }
                        // else {
                        //
                        //     type = $('#data-type-select').val();
                        //
                        //     if ( type && type.toString() !== "null" ) {
                        //
                        //         // add additional field selection menu
                        //         showAdvancedSearchDataField(type);
                        //
                        //         // populate additional field drop-downs
                        //         setAdditionalSearchFilter( fieldName, predicate, fieldValue, model, i - 1 );
                        //     }
                        // }
                    }
                }
            }
        }
    }
}

/**
 * Set advanced search filters values in the UI based on the filters string.
 * @param filters {string} Filters URL string.
 */
function setAdvancedSearchFiltersValues( filters ) {

    var dataType,
        model,
        filtersArray,
        filter,
        filterArray,
        fieldName,
        predicate,
        fieldValue,
        i;

    if ( filters ) {

        var UIMenuFilters = $('#model-fields');
        var selectedField;
        if ( UIMenuFilters && UIMenuFilters.find(":selected") ) {
            selectedField = UIMenuFilters.find(":selected").val();
            // If selected field is not the same as the URL field, don't fill in the value
        }

        // get data model from the global store
        dataType = getTypeStringFromURL( Backbone.history.getFragment() );
        model = getDataModel( dataType, false );

        // parse the filters string
        filtersArray = filters.split(';');
        if ( filtersArray && filtersArray.length > 0 ) {

            for ( i = 0; i < filtersArray.length; i++ ) {
                // Display URL filters in the UI menu
                filter = filtersArray[ i ];

                if ( filter ) {

                    filterArray = filter.split('|');
                    if ( filterArray && filterArray.length === 3 ) {

                        fieldName = filterArray[ 0 ] ;
                        predicate = filterArray[ 1 ];
                        fieldValue = filterArray[ 2 ];

                        if ( fieldName && selectedField === fieldName ) {

                            var fieldObject = getFieldObjectByName( model, fieldName );

                            if ( fieldObject ) {

                                var fieldType = fieldObject.type;

                                if ( fieldType && fieldValue ) {

                                    var enumeration = $('#data-input-enum');
                                    var text = $('#data-input-text');

                                    if ( fieldType === "object" ) {
                                        // TODO show the third field drop-down
                                        // Get the type of the second field and select it in the drop-down
                                        // show text input
                                        if (text) {
                                            text.val(fieldValue);
                                        }
                                    } else if (fieldType === "date") {

                                        // Set enumeration value if it exist
                                        if (enumeration) {
                                            enumeration.val( fieldValue );
                                        }
                                        // show calendar input for the second calendar if predicate is "between"
                                        if (predicate === "between") {

                                            var valueArray = fieldValue.split(",");
                                            if (valueArray && valueArray.length === 2) {
                                                fieldValue = valueArray[0];
                                                var date2 = $('#data-input-date-2');
                                                if (date2) {
                                                    var valueString2 = formatDate(valueArray[1]);
                                                    if (valueString2) {
                                                        date2.val(valueString2);
                                                    }
                                                }
                                            }
                                        }

                                        var date1 = $('#data-input-date');
                                        if (date1) {
                                            var valueString = formatDate(fieldValue);
                                            if (valueString) {
                                                date1.val(valueString);
                                            }
                                        }
                                    } else if (fieldType === "enumeration" && fieldObject.options && hasKeys(fieldObject.options)) {
                                        if (enumeration) {
                                            enumeration.val(fieldValue);
                                        }
                                    } else {
                                        // Default: show text input
                                        // Check if enumeration values exist
                                        if (enumeration) {
                                            enumeration.val(fieldValue);
                                        }
                                        if (text) {
                                            text.val(fieldValue);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Set additional advanced search filters values in the UI based on the filters string.
 * @param el {object} Field DOM element.
 * @param filters {string} Filters URL string.
 */
function setAdditionalAdvancedSearchFiltersValues( el, filters ) {

    var dataType;
    var model;
    var filtersArray;
    var filter;
    var filterArray;
    var fieldName;
    var predicate;
    var fieldValue;
    var i;

    if ( filters && el ) {
        var selectedField;
        var parent = el.parent();
        if ( parent ) {
            var sibling = parent.find('.additional-model-fields');
            if ( sibling ) {
                var selectEl = sibling.find(":selected");
                if ( selectEl ) {
                    selectedField = selectEl.val();
                }
                // If selected field is not the same as the URL field, don't fill in the value
            }
        }

        // get data model from the global store
        dataType = getTypeStringFromURL( Backbone.history.getFragment() );
        model = getDataModel( dataType, false );

        // parse the filters string
        filtersArray = filters.split(';');
        if ( filtersArray && filtersArray.length > 0 ) {
            for ( i = 0; i < filtersArray.length; i++ ) {
                // Display URL filters in the UI menu
                filter = filtersArray[ i ];

                if ( filter ) {

                    filterArray = filter.split('|');
                    if ( filterArray && filterArray.length === 3 ) {
                        fieldName = filterArray[ 0 ];
                        predicate = filterArray[ 1 ];
                        fieldValue = filterArray[ 2 ];

                        if ( fieldName && selectedField === fieldName ) {

                            var fieldObject = getFieldObjectByName( model, fieldName );

                            if ( fieldObject ) {

                                var text = el.find( '.additional-data-input-text' );
                                var date1 = el.find( '.additional-data-input-date' );
                                var date2 = el.find( '.additional-data-input-date-2' );
                                var enumeration = el.find( '.additional-data-input-enum' );

                                var fieldType = fieldObject.type;

                                if ( fieldType && fieldValue ) {

                                    if ( fieldType === "object" ) {
                                        // TODO show the third field drop-down
                                        // Get the type of the second field and select it in the drop-down
                                        // show text input
                                        if ( text ) {
                                            text.val( fieldValue );
                                        }
                                    } else if ( fieldType === "date" ) {
                                        // Set enumeration value if it exist
                                        if (enumeration) {
                                            enumeration.val( fieldValue );
                                        }
                                        // show calendar input for the second calendar if predicate is "between"
                                        if ( predicate === "between" ) {

                                            var valueArray = fieldValue.split(",");
                                            if (valueArray && valueArray.length === 2) {
                                                fieldValue = valueArray[0];
                                                if (date2) {
                                                    var valueString2 = formatDate(valueArray[1]);
                                                    if (valueString2) {
                                                        date2.val(valueString2);
                                                    }
                                                }
                                            }
                                        }

                                        if (date1) {
                                            var valueString = formatDate(fieldValue);
                                            if (valueString) {
                                                date1.val(valueString);
                                            }
                                        }
                                    } else if (fieldType === "enumeration" && fieldObject.options && hasKeys(fieldObject.options)) {
                                        // Set enumeration value if it exist
                                        if (enumeration) {
                                            enumeration.val(fieldValue);
                                        }
                                    } else {
                                        // Set enumeration value if it exist
                                        if (enumeration) {
                                            enumeration.val( fieldValue );
                                        }
                                        if ( text ) {
                                            text.val( fieldValue );
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}


/**
 * Set first field drop-down. Set field predicate and field input based on field type and value.
 * @param name {string} - field name
 * @param predicate {string} - predicate value
 * @param value {string} - field value
 * @param model {object} - JSON data model
 */
function setAdvancedSearchFilter( name, predicate, value, model ) {

    var compoundNameArray,
        compoundName,
        nestedName,
        fieldSelect,
        fieldObject,
        propertiesSelect,
        predicateSelect,
        isNested = false;

    if ( name && predicate && value && model ) {
        // select field from the drop-down
        fieldSelect = $( '#model-fields' );
        if ( fieldSelect ) {

            // check if field name is nested
            if ( name.indexOf(".") > -1 ) {
                compoundNameArray = name.split(".");
                if ( compoundNameArray && compoundNameArray.length === 2 ) {
                    isNested = true;
                    compoundName = compoundNameArray[ 0 ];
                    nestedName = compoundNameArray[ 1 ];

                    // select the first field from the drop-down
                    fieldSelect.val( compoundName);

                }
            } else {
                fieldSelect.val( name );
            }

            fieldSelect.change();
        }

        fieldObject = getFieldObjectByName( model, name );

        if ( fieldObject ) {

            // if it is a nested field, show the second field drop-down and select it
            if ( isNested ) {
                // select the second field drop-down
                propertiesSelect = $('#field-properties');
                if ( nestedName ) {
                    propertiesSelect.val( nestedName );
                    propertiesSelect.change();
                }
            }

            // select predicate from the drop-down
            predicateSelect = $( '#field-predicates' );
            if ( predicateSelect ) {
                predicateSelect.val( predicate );
                predicateSelect.change();
            }
        }
    }
}

/**
 * Set additional filter drop-down. Set field predicate and field input based on field type and value.
 * @param name {string} - field name
 * @param predicate {string} - predicate value
 * @param value {string} - field value
 * @param model {object} - JSON data model
 * @param index {number} - additional field index, starts at 0
 */
function setAdditionalSearchFilter( name, predicate, value, model, index ) {

    var additionalFields,
        additionalField,
        compoundNameArray,
        compoundName,
        nestedName,
        fieldSelect,
        fieldObject,
        fieldType,
        propertiesSelect,
        predicateSelect,
        isNested = false;

    if ( name && predicate && value && model ) {

        // find additional field element
        additionalFields = $( '#additional-conditional' );
        if ( additionalFields ) {
            additionalField = additionalFields.find( '#additional-field-' + index );

            if ( additionalField && additionalField.length === 1 ) {

                // select field from the drop-down
                fieldSelect = $( additionalField ).find( '.additional-model-fields' );
                if ( fieldSelect ) {

                    // check if field name is nested
                    if ( name.indexOf(".") > -1 ) {
                        compoundNameArray = name.split(".");
                        if ( compoundNameArray && compoundNameArray.length === 2 ) {
                            isNested = true;
                            compoundName = compoundNameArray[ 0 ];
                            nestedName = compoundNameArray[ 1 ];

                            // select the first field from the drop-down
                            fieldSelect.val( compoundName );
                        }
                    } else {
                        fieldSelect.val( name );
                    }
                    fieldSelect.change();
                }

                fieldObject = getFieldObjectByName( model, name );
                if ( fieldObject ) {

                    fieldType = fieldObject.type;

                    // if it is a nested field, show the second field drop-down and select it
                    if ( isNested ) {
                        // select the second field drop-down
                        propertiesSelect = $( additionalField ).find( '.additional-field-properties' );
                        if ( nestedName ) {
                            propertiesSelect.val( nestedName );
                            propertiesSelect.change();
                        }
                    }

                    // select predicate from the drop-down

                    predicateSelect = $( additionalField ).find( '.additional-field-predicates' );
                    if ( predicateSelect ) {
                        predicateSelect.val( predicate );
                        predicateSelect.change(index);
                    }

                    // fill in field value
                    // if ( fieldType && value )  {
                    //
                    //     if ( fieldType === "object" ) {
                    //         // TODO show the third field drop-down
                    //         // Get the type of the second field and select it in the drop-down
                    //     } else if ( fieldType === "date") {
                    //
                    //         // show calendar input for the second calendar if predicate is "between"
                    //         if ( predicate === "between" ) {
                    //
                    //             valueArray = value.split(",");
                    //             if ( valueArray && valueArray.length === 2 ) {
                    //                 value = valueArray[ 0 ];
                    //                 date2 = $( additionalField ).find('.additional-data-input-date-2');
                    //                 if ( date2 ) {
                    //                     valueString2 = formatDate( valueArray[ 1 ] );
                    //                     if ( valueString2 ) {
                    //                         date2.val( valueString2 );
                    //                     }
                    //                 }
                    //             }
                    //         }
                    //
                    //         date1 = $( additionalField ).find( '.additional-data-input-date' );
                    //         if ( date1 ) {
                    //             valueString = formatDate( value );
                    //             if ( valueString ) {
                    //                 date1.val( valueString );
                    //             }
                    //         }
                    //     } else if ( fieldType === "enumeration" && fieldObject.options && hasKeys( fieldObject.options )) {
                    //        // enumeration = $( '#data-input-enum' );
                    //        var  enumeration = $( additionalField ).find( '.additional-data-input-enum' );
                    //         if ( enumeration ) {
                    //             enumeration.val( value );
                    //         }
                    //
                    //     } else {
                    //         // show text input
                    //         text = $( additionalField ).find( '.additional-data-input-text' );
                    //         if ( text ) {
                    //             text.val( value );
                    //         }
                    //     }
                    // }
                }
            }
        }
    }
}

/**
 * Initialize first field predicate drop-down element
 * @param name {string} Field name.
 * @param model {object} JSON data model.
 * @param dataModelName {string} Data model name.
 */
function initializeFieldPredicates( name, model, dataModelName ) {

    var s,
        field,
        type;
    // based on the type of field selected, build available drop-downs
    // string --> text input
    // date --> date input
    // object --> additional inputs

    s = $( 'div#advanced-search-options' );
    if ( s.length > 0 ) {

        field = getFieldObjectByName( model, name );

        if ( field ) {
            type = field.type;
            populateFieldPredicates( field, type, dataModelName );
        }
    }
}

/**
 * Populate predicate drop-down based on selected field.
 * @param field {object} Field object.
 * @param type {string} Field type.
 * @param dataModelName {string} Data model name.
 */
function populateFieldPredicates( field, type, dataModelName ) {

    var predicates,
        predicate,
        select,
        el,
        i;

    if ( type === "object" ) {
        // show field properties drop-down
        initializeFieldProperties( field );
    }
    else {
        predicates = getPredicatesByType( type );

        // Dynamically add predicate options
        if ( predicates ) {
            select = $( '#field-predicates' );
            if ( select && select.length === 1 ) {
                el = select[0];

                if ( el && el.options ) {
                    // Reset available options
                    el.options.length = 0;

                    // Add model fields
                    for ( i = 0; i < predicates.length; i++ ) {
                        predicate = predicates[ i ];
                        if ( predicate ) {
                            el.options[ i ] = new Option( predicate.get("label"), predicate.get("url") );
                        }
                    }
                }
            }

            select.show();

            // check if field model has options
            if ( type === "enumeration" && field ) {
                if ( ! field.options || ( field.options && hasKeys( field.options ) )) {
                    // Set text type for enumeration fields with no options
                    field.type = "string";
                }
            }

            // Show field aggregations as input drop-down values
            getFieldAggregations( field, select, dataModelName, 1, 5 );

        }
    }
}

/**
 * Get field ad-hoc aggregations from Explore Manager.
 * @param field {object} Field object.
 * @param select {object} DOM element of the drop-down display.
 * @param dataModelName {string} Data model name.
 * @param tryNumber {number} Number of times the function has been called.
 * @param maxTries {number} Maximum number of times the function will be called.
 */
function getFieldAggregations( field, select, dataModelName, tryNumber, maxTries ) {

    if ( field ) {
        var fieldName = field.name;
        var fieldType = field.type;
        var options = field.options;
        var aggType = 'count'; // Aggregation type is always count for Advanced Search

        if ( fieldName && fieldType && dataModelName ) {

            var aggregations;
            var aggSort = '_key';
            var aggOrder = 'asc';
            var url = getFieldAggregationURL( dataModelName, field, aggType, aggSort, aggOrder );

            if ( url ) {
                $.ajax({
                    url: url,
                    data: {},
                    dataType: 'json'
                })
                    .done( function( data ) {

                        if ( data ) {
                            aggregations = data.aggregations;
                        }
                        initializeFieldInputs( fieldType, options, aggregations, dataModelName );

                        // Listen for change event for field predicates
                        if ( select ) {

                            select.change( function() {

                                var selected = $( this ).find( "option:selected" );

                                if ( selected ) {
                                    var name = selected.attr("value");
                                    if ( name ) {

                                        $( '#data-input' ).show();
                                        if ( name === "between" ) {
                                            $( '#data-date-calendar-2' ).show();
                                        } else {
                                            $( '#data-date-calendar-2' ).hide();
                                        }
                                    }
                                }
                            });
                        }
                    })
                    .fail( function( jqXHR, textStatus, errorThrown ) {
                        console.log('[' + new Date() + '] Error occurred in getting ad-hoc aggregations for url ' + url + ':');
                        console.log(textStatus);
                        console.log(errorThrown);
                        if ( tryNumber <= maxTries ) {
                            getFieldAggregations( field, select, dataModelName, tryNumber + 1, maxTries );
                        } else {
                            initializeFieldInputs( fieldType, options, null, dataModelName );
                        }
                    });
            }
        }
    }
}

/**
 * Populate field properties drop-down for nested field
 * @param field {object} - nested field model
 */
function initializeFieldProperties( field ) {

    var s,
        type,
        properties,
        select,
        el,
        sortedProperties,
        property,
        selected,
        name,
        i;

    // Show field properties for fields of type object
    s = $( 'div#advanced-search-options' );
    if ( s.length > 0 ) {

        if ( field ) {

            type = field.type;

            if ( type === "object" ) {

                properties = field.properties;

                if ( properties ) {

                    // Dynamically add properties options

                    select = $( '#field-properties' );
                    if ( select && select.length === 1 ) {
                        el = select[ 0 ];

                        if ( el && el.options ) {
                            // Reset available options
                            el.options.length = 0;

                            // Add - Select data field - option
                            el.options[ 0 ] = new Option( "- Select data field -", null );

                            // Add model fields
                            sortedProperties = arrayUnique( properties.sort( compareByLabel ) );
                            for ( i = 1; i < sortedProperties.length; i++ ) {
                                property = sortedProperties[ i ];
                                if ( property ) {
                                    el.options[ i ] = new Option( property.label, property.name );
                                }
                            }

                        }

                        $('.field-conditional').show();
                        $("#field-predicates").hide();
                        $("#data-input").hide();

                        select.show();

                        // Listen for change event for field predicates
                        select.change( function () {
                            selected = $( this ).find( "option:selected" );
                            if ( selected ) {
                                name = selected.attr( "value" );
                                if ( name ) {
                                    initializeNestedFieldPredicates( field, name );
                                }
                            }
                        });
                    }
                }
            }
        }
    }
}

/**
 * Initialize predicate drop-down for a nested field
 * @param field {object} - field model
 * @param name {string} - field name
 */
function initializeNestedFieldPredicates( field, name ) {
    var properties,
        nestedField,
        type;

    // get the type from the field properties by nested field name

    properties = field.properties;
    nestedField = getFieldProperty( properties, name );

    if ( nestedField ) {
        type = nestedField.type;
        populateFieldPredicates( nestedField, type, null );
    }
}

/**
 * Get an array of predicate URL values based on field type
 * @param type {string} - field type
 * @returns {Array}
 */
function getPredicatesByType( type ) {
    var labels = [],
        typePredicates = [],
        model,
        i;

    // Search API v1 does not implement "contains" and "does not contain" predicate queries
    // String, enumeration, boolean, objects and default types have two predicates: "equals" and "not equal"
    // Date type fields have predicates "equal", "not equal", "less than", "greater than" and "between"

    if ( type ) {
        switch ( type ) {
            case FieldTypes.enumeration:
            case FieldTypes.largeEnumeration:
            case FieldTypes.boolean:
            case FieldTypes.string:
                typePredicates = [ Predicates.equals, Predicates.notEqual ];
                break;
            case FieldTypes.number:
            case "long":
            case "integer":
            case "date":
            case FieldTypes.date:
                typePredicates = [ Predicates.equals, Predicates.notEqual, Predicates.lessThan, Predicates.greaterThan, Predicates.between ];
                break;
            default:
                typePredicates = [ Predicates.equals, Predicates.notEqual ];
        }
    } else {
        // default to object/text type
        typePredicates = [ Predicates.equals, Predicates.notEqual ];
    }


    for ( i = 0; i < typePredicates.length; i++ ) {
        model = App.globalState.fieldPredicates.findWhere( { value: typePredicates[ i ] } );
        if ( model ) {
            labels.push( model );
        }
    }

    return labels;
}

/**
 * Initialize field input element based on field type. Type cannot be "object".
 * @param type {string} Simple field type e.g. "string", "number", etc.
 * @param options {object|null} JavaScript object containing options for enumeration type field or null.
 * @param aggregations {object} Field aggregations object.
 */
function initializeFieldInputs( type, options, aggregations, dataModelName ) {

    var input;
    var date;
    var date2;
    var enumeration;
    var text;
    var buckets;

    // Assume that type is not an object
    if ( type !== "object" ) {

        input = $( '#data-input' );

        if ( input ) {
            text = input.find('#data-input-text');
            date = input.find('#data-input-date');
            date2 = input.find('#data-input-date-2');
            enumeration = input.find('#data-input-enum');

            if ( aggregations ) {

                for ( var key in aggregations ) {

                    // makes sure to pick only a matching aggregation
                    if ( key.includes( dataModelName ) ) {                  // ===== 

                        if ( aggregations.hasOwnProperty( key )) {
                            var bucketsObj = aggregations[ key ];
                            if ( bucketsObj ) {
                                buckets = bucketsObj.buckets;
                            }
                        }
                    }
                }
            }

            if ( buckets && buckets.length > 0 && text && date ) {
                // Display aggregations from buckets
                text.hide();
                date.hide();
                showAggregationDropdown( enumeration, buckets );

            } else {
                if ( type === "date" && text && date && date2 && enumeration ) {
                    // TODO - fix (date picker doesn't work)
                    // show calendar and hide text and enum inputs
                    text.hide();
                    date.val( null );
                    date.attr('placeholder', 'MM/DD/YYYY (No values found)');
                    date2.val( null );
                    date2.attr('placeholder', 'MM/DD/YYYY (No values found)');

                    // create a date picker input
                    // date.datepicker({
                    //     forceParse: false,
                    //     autoclose: true,
                    //     todayHighlight: true,
                    //     toggleActive: true
                    // });

                    // create a second date picker input
                    // date2.datepicker({
                    //     forceParse: false,
                    //     autoclose: true,
                    //     todayHighlight: true,
                    //     toggleActive: true
                    // });

                    date.parent().show();
                    date.show();
                    enumeration.hide();
                } else if ( type === "enumeration" && text && date ) {
                    text.hide();
                    date.hide();
                    showEnumerationDropdown( enumeration, options );
                } else if ( text && date && enumeration ) {

                    // Show text input box
                    text.val(null);
                    text.attr('placeholder', 'No values found');
                    text.show();
                    date.hide();
                    enumeration.hide();
                }
            }
            input.show();
            $('.field-conditional').show();
        }

        // Set field filter if it is found in the URL
        if ( Backbone && Backbone.history ) {
            var filters = getFiltersStringFromURL( Backbone.history.getFragment() );
            if ( filters ) {
                setAdvancedSearchFiltersValues( filters );
                setAdditionalSearchFilters( filters );
            }
        }
    }
}

/**
 * Display selected filters after the first filter is shown.
 * @param filters {string} Filters URL string.
 */
function setAdditionalSearchFilters( filters ) {


    if ( filters ) {

        // get data model from the global store
        var dataType = getTypeStringFromURL( Backbone.history.getFragment() );
        var model = getDataModel( dataType, false );

        // parse the filters string
        var filtersArray = filters.split(';');
        if ( filtersArray && filtersArray.length > 0 ) {
            for ( var i = 0; i < filtersArray.length; i++ ) {
                // Display URL filters in the UI menu
                var filter = filtersArray[ i ];

                if ( filter ) {

                    var filterArray = filter.split('|');
                    if ( filterArray && filterArray.length === 3 ) {
                        var fieldName = filterArray[ 0 ];
                        var predicate = filterArray[ 1 ];
                        var fieldValue = filterArray[ 2 ];

                        if ( i !== 0 ) {
                            var type = $('#data-type-select').val();

                            if ( type && type.toString() !== "null" ) {

                                // add additional field selection menu
                                showAdvancedSearchDataField(type);

                                // populate additional field drop-downs
                                setAdditionalSearchFilter( fieldName, predicate, fieldValue, model, i - 1 );
                            }
                        }
                    }
                }
            }
        }
    }
}

/**
 * Construct and show enumeration dropdown element
 * @param enumeration {object} - DOM enumeration select element
 * @param options {object} - JavaScript object with key-value pairs for enumeration values
 */
function showEnumerationDropdown( enumeration, options ) {

    var elem,
        i,
        key;

    // Show enumeration drop-down with values
    if ( enumeration && enumeration.length === 1 && options ) {
        elem = enumeration[0];

        if ( elem && elem.options ) {
            // Reset available options
            elem.options.length = 0;

            // Add - Select field value - option
            elem.options[ 0 ] = new Option( "- Select field value -", null );

            // Add model fields from the options object
            i = 1;
            for ( key in options ) {
                if ( options.hasOwnProperty( key ) ) {
                    elem.options[ i ] = new Option( options[ key ], key );
                    i++;
                }
            }
        }
        enumeration.show();
    }
}

/**
 * Construct and show field aggregation dropdown element.
 * @param enumeration {object} DOM enumeration select element
 * @param options {Array} Array of aggregation keys: { key: {string}, doc_count: {number}}.
 */
function showAggregationDropdown( enumeration, options ) {

    var elem;
    var i;

    // Show enumeration drop-down with values
    if ( enumeration && enumeration.length === 1 && options ) {
        elem = enumeration[0];

        if (elem && elem.options) {
            // Reset available options
            elem.options.length = 0;

            // Add - Select field value - option
            elem.options[0] = new Option("- Select field value -", null);

            // Add model fields from the options object
            i = 1;
            for ( var j = 0; j < options.length; j++ ) {
                var option = options[j];
                if (option) {
                    var label =  option["key_as_string"] || option[ "key" ];

                    // limits text length to 120 characters and adds ellipsis to indicate truncation
                    if ( label.length > 120 ) {
                        var label = label.slice( 0, 120 ) + ' ••• ';
                    };

                    var optionLabel = label + ' [ ' + option[ "doc_count" ] + ' ]';

                    elem.options[i] = new Option( optionLabel, option["key"] );
                    i++;
                }
            }
        }
        enumeration.show();
    }
}

/**
 * Attach event listeners to advanced search buttons
 */
function initializeAdvancedSearchButtons() {

    // Hide loading icon
    hideLoadingIcon('content-icon-id');

    // Show page content
    var searchpage = $('#search-layout');
    if ( searchpage ) {
        searchpage.show();
    }

    /**
     * Listen for the click event for advanced search button
     */
    $('#advanced-search-button').on('click', function (e) {
        var type,
            query,
            typeSelect,
            selectedType,
            typeValue,
            typeLabel,
            dataModel,
            success,
            baseUrl,
            path;

        e.preventDefault();

        typeSelect = $( '#data-type-select' );
        if ( typeSelect ) {
            type = typeSelect.val();

            if ( type && type !== "null" ) {

                // remove previous filters
                App.globalState.currentFilters.reset( null );

                selectedType = typeSelect.find( "option:selected" );
                typeValue = selectedType.attr("value");

                if ( selectedType && typeValue ) {
                    // Add data type to global filters

                    typeLabel = selectedType.text();
                    if ( ! typeLabel ) {
                        typeLabel = typeValue;
                    }
                    addFilterToGlobal( "type", typeLabel, typeValue, typeLabel, "eq", "string" );
                }

                // Get data type model from global store
                dataModel = getDataModel( type, false );

                // check if field is selected
                // Add field filter to global filters
                success = addModelFields( dataModel );
                if ( success ) {

                    // Update URL with query and filters
                    // Do search and display results
                    // Update global query
                    query = $( '#search-query' );
                    if ( query ) {
                        App.globalState.query = cleanInput(query.val());
                        if ( App.globalState.query === "" ) {
                            App.globalState.query = "all";
                        } else {

                        }
                    } else {
                        App.globalState.query = "all";
                    }

                    if ( window && window.location ) {
                        path = window.location.pathname;
                        if ( path && path.length > 0 ) {
                            baseUrl = path.substr(1 );

                            var nosearch = getNoSearchFlagFromURL();
                            if ( nosearch === "true" ) {
                                // Do not perform Advanced Search and do not display the results
                                // Send the data back to the referrer
                                sendAdvancedSearchData( );

                            } else {
                                updateURL( baseUrl, App.globalState.query, true );
                            }
                        }
                    }
                }
            }
            else {

                // if both source and query are empty, add a message that at least one of the data type or query is required
                // source is undefined
                // check if there's a query
                query = $('#search-query').val();

                if ( query ) {

                    // remove all filters from global store
                    App.globalState.currentFilters.reset(null);

                    // if there is a valid query, do a search across all data types
                    App.globalState.query = cleanInput( query );

                    if ( window && window.location ) {
                        path = window.location.pathname;
                        if ( path && path.length > 0 ) {
                            baseUrl = path.substr(1);

                            var nosearch = getNoSearchFlagFromURL();
                            if ( nosearch === "true" ) {
                                // Do not perform Advanced Search and do not display the results
                                // Send the data back to the referrer
                                sendAdvancedSearchData(  );

                            } else {
                                updateURL( baseUrl, App.globalState.query, true );
                            }
                        }
                    }

                    // hide error message
                    $('.invalid-form-error-message')
                        .html('')
                        .toggleClass('ok', true);


                } else {

                    // show error message

                    $('.invalid-form-error-message')
                        .html('You must fill either the query text box or select a data type, or both')
                        .toggleClass( 'ok', false );

                }
            }
        } else {
            // show error message

            $('.invalid-form-error-message')
                .html('You must select a data type first')
                .toggleClass( 'ok', false );
        }

    });

    /**
     * Toggle advanced search menu
     */
    $('#advanced-search-options').find('.fa-caret-square-down').click(function () {
        $('#advanced-search-menu').slideToggle();
    });

    /**
     * Remove all filters from advanced search UI menu and URL
     */
    $( '#advanced-search-clear' ).on( 'click', function ( e ) {

        e.preventDefault();
        // remove all filters from global store
        App.globalState.currentFilters.reset( null );

        var nosearch = getNoSearchFlagFromURL();
        if ( nosearch === "true" ) {

            // De-select the top-level data type
            $('#data-type-select').val("null");
            $('#data-type-select').change();

            $('#data-type-select option:eq(null)').prop('selected', true);

        } else {
            if ( window && window.location ) {
                var path = window.location.pathname;
                if ( path && path.length > 0 ) {
                    var baseUrl = path.substr(1);
                    updateURL( baseUrl, App.globalState.query, true );
                }
            }
        }
    });

    /**
     * Add a drop-down menu for an additional model filter
     */
    $( '#add-advanced-search-field' ).on( 'click', function( e ) {
        var type;
        e.preventDefault();

        // check that the data type is selected first
        type = $( '#data-type-select' ).val();

        if ( type && type !== "null" ) {
            // hide error message
            $('.invalid-form-error-message')
                .html('')
                .toggleClass( 'ok', true );

            // add new field selection menu
            showAdvancedSearchDataField( type );
        } else {

            // show error message
            $('.invalid-form-error-message')
                .html('You must select a data type before adding fields')
                .toggleClass( 'ok', false );
        }
    });

    /**
     * Listen for click event on Basic Search button
     */
    $('#basic-edi-search').on('click', function () {

        updateURL( "/search", App.globalState.query, true );
    });
}

/**
 * Add selected model fields to the global filters store. Returns true if all selected fields were added successfully.
 * @param dataModel {object} - JSON data model
 * @returns {boolean}
 */
function addModelFields( dataModel ) {

    var fieldSelect,
        field,
        fieldName,
        propertiesName,
        fieldLabel,
        fieldProperties,
        properties,
        success = false,
        additionalFieldsSuccess = false;

    fieldSelect = $( '#model-fields' );

    if ( fieldSelect && fieldSelect.is(":visible") ) {
        field = fieldSelect.find( "option:selected" );
        if ( field ) {
            fieldName = field.attr("value");
            if ( fieldName && fieldName !== "null" ) {

                // check if field properties is visible and selected
                fieldProperties = $( '#field-properties' );
                if ( fieldProperties && fieldProperties.is(":visible") ) {
                    properties = fieldProperties.find( "option:selected" );
                    if ( properties ) {
                        propertiesName = properties.attr("value");
                        if ( propertiesName ) {
                            fieldName += "." + propertiesName;
                            fieldLabel = properties.attr("label");
                        }
                    }
                } else {
                    fieldLabel = field.attr( "label" ); // TODO use the text() property
                }
                success = addFieldFilterToGlobal( dataModel, fieldName, fieldLabel );
            } else {
                success = true;
            }
        }

        // check if selection of additional fields is valid
        additionalFieldsSuccess = addAdditionalFields( dataModel );
    } else {
        // Only the data type is selected
        success = true;
        additionalFieldsSuccess = true;
    }

    return success && additionalFieldsSuccess;
}

/**
 * Add additional fields to the global store. Returns true if all additional fields were added successfully.
 * @param dataModel {object} - JSON data model
 * @returns {boolean}
 */
function addAdditionalFields( dataModel ) {

    var additionalFields,
        additionalField,
        fieldSelect,
        field,
        fieldName,
        propertiesName,
        fieldLabel,
        fieldProperties,
        properties,
        successArray = [],
        success = false,
        i;

    additionalFields = $( '#additional-conditional' ).children();
    if ( additionalFields ) {

        // Look at each additional field value, predicate and value
        for ( i = 0; i < additionalFields.length; i++ ) {
            additionalField = additionalFields[i];

            fieldSelect = $( additionalField ).find( '.additional-model-fields' );

            if ( fieldSelect && fieldSelect.is(":visible") ) {
                field = fieldSelect.find( "option:selected" );
                if ( field ) {
                    fieldName = field.attr("value");
                    if ( fieldName && fieldName !== "null" ) {

                        // check if field properties is visible and selected
                        fieldProperties = $(additionalField).find( '.additional-field-properties' );
                        if ( fieldProperties && fieldProperties.is(":visible") ) {
                            properties = fieldProperties.find( "option:selected" );
                            if ( properties ) {
                                propertiesName = properties.attr("value");
                                if ( propertiesName ) {
                                    fieldName += "." + propertiesName;
                                    fieldLabel = properties.attr("label");
                                }
                            }
                        } else {
                            fieldLabel = field.attr("label");
                        }

                        success = addAdditionalFieldFilterToGlobal( dataModel, fieldName, fieldLabel, additionalField );
                        if ( success ) {
                            successArray.push(success);
                        }
                    } else {
                        $(additionalField).find('.invalid-form-error-message')
                            .html('You must select a field')
                            .toggleClass( 'ok', false );
                    }
                }
            }
        }
        // compare the number of successful additions to the global store with the number of additional fields
        if ( successArray.length === additionalFields.length ) {
            success = true;
        }
    }

    return success;
}

/**
 * Add a field to the global store.
 * Returns true if field was added successfully.
 * Displays error messages if field form is invalid.
 * @param dataModel {object} - JSON data model
 * @param fieldName {string} - field name
 * @param fieldLabel {string} - field label
 * @returns {boolean}
 */
function addFieldFilterToGlobal( dataModel, fieldName, fieldLabel ) {
    var fieldType,
        fieldValue,
        predicate,
        propertiesName,
        fieldObject,
        advancedSearchForm,
        form,
        success = false;

    if ( fieldName ) {

        // Find field object from the model
        fieldObject = getFieldObjectByName( dataModel, fieldName );

        if ( fieldObject ) {
            fieldType = fieldObject.type;

            if ( fieldType ) {
                if ( fieldType === "object" ) {
                    propertiesName = getFieldPropertiesName();
                    if ( propertiesName ) {
                        // combine the two names into one
                        fieldName += "." + propertiesName;
                    }
                }

                // Add field predicate
                predicate = getFieldPredicate();

                // Find field input value
                fieldValue = getFieldValue( fieldType, predicate );

                if ( ! fieldValue ) {
                    // display error message

                    advancedSearchForm = $( '#advanced-search-options' );
                    // if ( typeof window.Parsley !== "undefined" ) {
                    //     form = advancedSearchForm.parsley();
                    //     form.validationResult = false;
                    // }

                    // show error message
                    if ( predicate === "between" ) {
                        $('.invalid-form-error-message')
                            .html('You must provide both field values. The second date must be greater than the first.')
                            .toggleClass( 'ok', false );
                    } else {
                        $('.invalid-form-error-message')
                            .html('You must provide a field value')
                            .toggleClass( 'ok', false );
                    }
                }
                if ( fieldName && predicate && fieldValue ) {
                    // add filter to global store
                    //addFilterToGlobal( field, label, value, displayValue, operator, type )
                    addFilterToGlobal( fieldName, fieldLabel, fieldValue, fieldLabel, predicate, fieldType );
                    success = true;
                }
            }
        } else {
            $('.invalid-form-error-message')
                .html('You must select a field')
                .toggleClass( 'ok', false );
        }
    }

    return success;
}

/**
 * Add additional field to the global store.
 * Returns true if field was added successfully.
 * Displays error messages if field form is invalid.
 * @param dataModel {object} - JSON data model
 * @param fieldName {string} - field name
 * @param fieldLabel {string} - field label
 * @param additionalField {object} - additional field model
 * @returns {boolean}
 */
function addAdditionalFieldFilterToGlobal( dataModel, fieldName, fieldLabel, additionalField ) {

    var fieldType,
        fieldValue,
        predicate,
        propertiesName,
        fieldObject,
        success = false;

    if ( fieldName ) {

        // Find field object from the model
        fieldObject = getFieldObjectByName( dataModel, fieldName );

        if ( fieldObject ) {
            fieldType = fieldObject.type;

            if ( fieldType ) {
                if ( fieldType === "object" ) {
                    propertiesName = getAdditionalFieldPropertiesName( additionalField );
                    if ( propertiesName ) {
                        // combine the two names into one
                        fieldName += "." + propertiesName;
                    }
                }

                // Add field predicate
                predicate = getAdditionalFieldPredicate(additionalField);

                // Find field input value
                fieldValue = getAdditionalFieldValue( fieldType, predicate, additionalField );

                if ( ! fieldValue ) {
                    // display error message

                    // show error message
                    if ( predicate === "between" ) {
                        $( additionalField).find('.invalid-form-error-message')
                            .html('You must provide both field values. The second date must be greater than the first.')
                            .toggleClass( 'ok', false );
                    } else {
                        $( additionalField ).find( '.invalid-form-error-message' )
                            .html('You must provide a field value')
                            .toggleClass( 'ok', false );
                    }
                }
                if ( fieldName && predicate && fieldValue ) {
                    // add filter to global store
                    addFilterToGlobal( fieldName, fieldLabel, fieldValue, fieldLabel, predicate, fieldType );
                    success = true;
                }
            }
        } else {
            $( additionalField ).find( '.invalid-form-error-message')
                .html('You must select a field')
                .toggleClass( 'ok', false );
        }
    }

    return success;

}

/**
 * Get selected field properties name (value) for the first field
 * @returns {*}
 */
function getFieldPropertiesName() {
    // Get field properties if field is nested
    var propertiesName,
        propertiesSelect,
        propertiesSelected;

    propertiesSelect = $( '#field-properties' );
    if ( propertiesSelect && propertiesSelect.is( ":visible" ) ) {
        propertiesSelected = propertiesSelect.find( "option:selected" );

        if ( propertiesSelected ) {
            propertiesName = propertiesSelected.attr( "value" );
        }
    }
    return propertiesName;
}

/**
 * Get selected field properties name (value) for an additional field
 * @param additionalField {object} - additional field element
 * @returns {*}
 */
function getAdditionalFieldPropertiesName( additionalField ) {
    // Get field properties if field is nested
    var propertiesName,
        propertiesSelect,
        propertiesSelected;

    propertiesSelect = $( additionalField ).find( '.additional-field-properties' );
    if ( propertiesSelect && propertiesSelect.is( ":visible" ) ) {
        propertiesSelected = propertiesSelect.find( "option:selected" );

        if ( propertiesSelected ) {
            propertiesName = propertiesSelected.attr( "value" );
        }
    }
    return propertiesName;
}

/**
 * Get predicate selected value for the first field
 * @returns {*}
 */
function getFieldPredicate() {

    var predicate,
        predicateSelect,
        predicateSelected;

    predicateSelect = $( '#field-predicates' );
    if ( predicateSelect && predicateSelect.is( ":visible" ) ) {
        predicateSelected = predicateSelect.find( "option:selected" );
        if ( predicateSelected ) {
            predicate = predicateSelected.attr( "value" );
        }
    }
    return predicate;
}

/**
 * Get predicate selected value for an additional field
 * @param additionalField {object} - additional field element
 * @returns {*}
 */
function getAdditionalFieldPredicate( additionalField ) {
    var predicate,
        predicateSelect,
        predicateSelected;

    predicateSelect = $( additionalField ).find( '.additional-field-predicates' );
    if ( predicateSelect && predicateSelect.is( ":visible" ) ) {
        predicateSelected = predicateSelect.find( "option:selected" );
        if ( predicateSelected ) {
            predicate = predicateSelected.attr("value");
        }
    }
    return predicate;
}

/**
 * Get field input value for the first field
 * @param fieldType {string} - field type
 * @param predicate {string} - field predicate
 * @returns {*}
 */
function getFieldValue( fieldType, predicate ) {
    var fieldValue,
        inputSelect,
        textBox,
        date1,
        date2,
        date1Value,
        date2Value,
        enumeration;

    inputSelect = $( '#data-input' );
    if ( inputSelect && inputSelect.is( ":visible" ) ) {

        // check enumeration for input
        enumeration = $( '#data-input-enum' );

        // check text box for input
        textBox = $('#data-input-text');
        if ( textBox && textBox.is( ":visible" )) {
            fieldValue = textBox.val();
        }
        else if ( enumeration && enumeration.is(':visible')) {
            fieldValue = getEnumerationValue( enumeration );
        }
        // check if type is date and predicate is "between"
        else if ( fieldType === "date" ) {
            date1 = $( '#data-input-date' );
            if ( date1 && date1.is( ":visible" ) ) {
                date1Value = date1.val();
                if ( date1Value ) {
                    fieldValue = ( new Date( date1Value )).toISOString();

                    if ( predicate === "between" ) {

                        date2 = $( '#data-input-2' );

                        if ( date2 && date2.is(":visible")) {
                            date2Value = date2.val();
                            if ( date2Value ) {
                                fieldValue += "," + (new Date( date2Value )).toISOString();
                            } else {
                                fieldValue = null;
                            }
                        } else {
                            fieldValue = null;
                        }

                        // compare two values
                        if ( date2Value && date1Value && new Date( date2Value ) <= new Date( date1Value ) ) {
                            // show error message
                            fieldValue = null;
                        }
                    }
                }
            }
        }
        else if ( fieldType === "enumeration" ) {
            // check if enum drop-down is visible
            // if it is, get selected option
            fieldValue = getEnumerationValue( enumeration );
        } else if ( textBox ) {
            fieldValue = textBox.val();
        }
    }
    return fieldValue;
}

/**
 * Return enumeration select option value
 * @param enumeration {object} - select element with options
 * @returns {*}
 */
function getEnumerationValue( enumeration ) {
    var index,
        selected,
        fieldValue;
    if ( enumeration && enumeration.is(":visible") && enumeration.length === 1 ) {
        // Get the value of the selected option
        index = enumeration[0].selectedIndex;
        if ( index > 0 ) {
            selected = enumeration[0].options[ index ];
            if ( selected ) {
                fieldValue = selected.value;
            }
        }
    }
    return fieldValue;
}

/**
 * Get field input value for an additional field
 * @param fieldType {string} - field type
 * @param predicate {string} - field predicate
 * @param additionalField {object} - additional field element
 * @returns {*}
 */
function getAdditionalFieldValue( fieldType, predicate, additionalField ) {
    var fieldValue,
        inputSelect,
        textBox,
        date1,
        date2,
        date1Value,
        date2Value,
        enumeration;

    inputSelect = $( additionalField ).find( '.additional-data-input' );

    if ( inputSelect && inputSelect.is( ":visible" ) ) {

        // check enumeration for input
        enumeration = $( additionalField ).find( '.additional-data-input-enum' );

        // check text box for input
        textBox = $(additionalField).find( '.additional-data-input-text' );

        if ( textBox && textBox.is( ":visible" )) {
            fieldValue = textBox.val();
        }
        else if ( enumeration && enumeration.is(':visible')) {
            fieldValue = getEnumerationValue( enumeration );
        } // check if type is date and predicate is "between"
        else if ( fieldType === "date" ) {
            date1 = $(additionalField).find( '.additional-data-input-date' );
            if ( date1 && date1.is( ":visible" ) ) {
                date1Value = date1.val();
                if ( date1Value ) {
                    fieldValue = ( new Date( date1Value )).toISOString();

                    if ( predicate === "between" ) {

                        date2 = $(additionalField).find( '.additional-data-input-date-2' );

                        if ( date2 && date2.is(":visible")) {
                            date2Value = date2.val();
                            if ( date2Value ) {
                                fieldValue += "," + (new Date( date2Value )).toISOString();
                            } else {
                                fieldValue = null;
                            }
                        } else {
                            fieldValue = null;
                        }

                        // compare two values
                        if ( date2Value && date1Value && new Date( date2Value ) <= new Date( date1Value ) ) {
                            // show error message
                            fieldValue = null;
                        }
                    }
                }
            }
        } else if ( fieldType === "enumeration" ) {
            // check if enum drop-down is visible
            // if it is, get selected option
            fieldValue = getEnumerationValue( enumeration );
        } else if ( textBox ) {
            fieldValue = textBox.val();
        }
    }
    return fieldValue;
}

/**
 * Add additional field drop-down
 * @param type {string} - data type name
 */
function showAdvancedSearchDataField( type ) {

    var outerDiv,
        additionalFields,
        innerDiv,
        select,
        div,
        error,
        removeDiv,
        properties,
        predicates,
        inputDiv,
        textInput,
        date1Input,
        date1Inner,
        date2Input,
        date2Inner,
        enumInput;

    // check how many fields have been shown already
    outerDiv = $('#additional-conditional');
    if ( outerDiv && outerDiv.length === 1 ) {
        additionalFields = outerDiv.children();
        if ( additionalFields ) {

            // dynamically add additional field drop-down

            innerDiv = document.createElement('div');
            innerDiv.id = "additional-field-" + additionalFields.length;
            outerDiv.append(innerDiv);

            // Add select element (drop-down) that will hold model's fields
            select = document.createElement('select');
            select.className = "additional-model-fields";
            select.name = select.className;
            innerDiv.appendChild( select );

            // Add wrapper element for conditional elements: properties, predicates and inputs
            div = document.createElement('div');
            div.className = "additional-field-conditional";
            innerDiv.appendChild( div );

            // Add error message element
            error = document.createElement('div');
            error.className = "invalid-form-error-message";
            innerDiv.appendChild(error);

            // Add remove field button element
            removeDiv = document.createElement('input');
            removeDiv.className = "button button-red-small remove-field";
            removeDiv.type = "button";
            removeDiv.value = "Remove field";
            removeDiv.title = "Remove field";
            removeDiv.id = "remove-field-" + additionalFields.length;
            innerDiv.appendChild( removeDiv );

            // Add field properties drop-down
            properties = document.createElement('select');
            properties.className = "additional-field-properties";
            properties.title = "Field properties";
            properties.name = properties.className;
            properties.hidden = "hidden";

            div.appendChild( properties );

            // Add field predicates drop-down
            predicates = document.createElement('select');
            predicates.className = "additional-field-predicates";
            predicates.title = "Field predicates";
            predicates.name = predicates.className;
            predicates.hidden = "hidden";

            div.appendChild( predicates );

            // Add field data inputs
            inputDiv = document.createElement('div');
            inputDiv.className = "additional-data-input";
            inputDiv.hidden = "hidden";

            // Add various input options

            // Input text
            textInput = document.createElement('input');
            textInput.type = "text";
            textInput.className = "additional-data-input-text";
            textInput.name = "input-text";
            textInput.title = "Input text";
            textInput.hidden = "hidden";

            inputDiv.appendChild( textInput );

            // Input first date
            date1Input = document.createElement('div');
            date1Input.className = "additional-data-date-calendar";
            date1Input.hidden = "hidden";

            date1Inner = document.createElement('input');
            date1Inner.type = "text";
            date1Inner.placeholder = "MM/DD/YYYY";
            date1Inner.className = "additional-data-input-date";
            date1Inner.name = "input-date";

            date1Input.appendChild(date1Inner);

            inputDiv.appendChild( date1Input );

            // Input second date

            date2Input = document.createElement('div');
            date2Input.className = "additional-data-date-calendar-2";
            date2Input.hidden = "hidden";

            date2Inner = document.createElement('input');
            date2Inner.type = "text";
            date2Inner.placeholder = "MM/DD/YYYY";
            date2Inner.className = "additional-data-input-date-2";
            date2Inner.name = "input-date-2";

            date2Input.appendChild(date2Inner);

            inputDiv.appendChild( date2Input );

            // Input enumeration

            enumInput = document.createElement('select');
            enumInput.className = "additional-data-input-enum";
            enumInput.name = "input-enum";
            enumInput.title = "Input enumeration";
            enumInput.hidden = "hidden";

            inputDiv.appendChild( enumInput );

            div.appendChild( inputDiv );

            // Add fields as options to the newly created select element
            populateAdditionalModelFields( type, select );

            // Listen for click events
            initializeFieldRemoveEvent();

        }
    }
}


/**
 * Populate model fields drop-down element for additional field.
 * @param type {string} Data type name.
 * @param el {object} Additional field DOM element
 */
function populateAdditionalModelFields( type, el ) {

    var dataModel,
        fields,
        field,
        selected,
        conditional,
        name,
        i;

    dataModel = getDataModel( type, false );

    if ( dataModel ) {

        fields = getModelProperties( dataModel );

        if ( fields && el ) {

            if ( el.options ) {
                // Reset available options
                el.options.length = 0;

                // Add - Select field - option
                el.options[ 0 ] = new Option( "- Select field -", null );

                // Add model fields
                for ( i = 1; i < fields.length; i++ ) {
                    field = fields[ i ];
                    if ( field ) {
                        el.options[ i ] = new Option( field.label, field.name );
                    }
                }
            }

            // Listen for change event to get the field predicates or properties
            $( el ).change( function( index ) {
                selected = $( this ).find( "option:selected" );
                if ( selected ) {
                    conditional = $( this ).next();
                    if ( conditional ) {
                        name = selected.attr( "value" );
                        if ( name && name.toString() !== "null") {
                            // hide previously shown inputs
                            $( this ).find( '.additional-data-input' ).hide();
                            conditional.hide();

                            // TODO - show loading icon

                            initializeAdditionalFieldPredicates( name, dataModel, type, this );
                        } else {
                            conditional.hide();
                        }
                    }
                }
            });
        }
    }
}

/**
 * Initialize first field predicate drop-down element
 * @param name {string} Field name.
 * @param model {object} JSON data model.
 * @param dataModelName {string} Data model name.
 * @param el {object} Additional field DOM element
 */
function initializeAdditionalFieldPredicates( name, model, dataModelName, el ) {

    var s;
    var field;

    // based on the type of field selected, build available drop-downs
    // string --> text input box
    // date --> calendar input
    // object --> other options

    s = $( 'div#advanced-search-options' );
    if ( s && s.length > 0 ) {

        field = getFieldObjectByName( model, name );

        if ( field ) {
            populateAdditionalFieldPredicates( field, dataModelName, el,false );
        }
    }
}

/**
 * Populate predicate drop-down based on field type
 * @param field {object} Field object.
 * @param dataModelName {string} Data model name.
 * @param el {object} Parent element of the additional field.
 * @param isNested {boolean} Flag if the field is nested.
 */
function populateAdditionalFieldPredicates( field, dataModelName, el, isNested ) {

    var select,
        wrapper,
        predicates,
        predicate,
        elem,
        i;

    if ( el ) {
        wrapper = $( el ).next( );

        if ( wrapper && wrapper.length === 1 ) {

            if ( field ) {
                var type = field.type;

                if ( type === "object" ) {
                    // show field properties drop-down
                    select = wrapper.find( '.additional-field-properties' );
                    initializeAdditionalFieldProperties( field, select );
                }
                else {
                    predicates = getPredicatesByType( type );

                    // Dynamically add predicate options
                    if ( predicates ) {
                        // Get the sibling of the field drop-down,
                        // which is a wrapper div that contains hidden predicates, properties and inputs

                        select = wrapper.find( '.additional-field-predicates' );
                        if ( select && select.length === 1 ) {
                            elem = select[0];

                            if ( elem && elem.options ) {
                                // Reset available options
                                elem.options.length = 0;

                                // Add model fields
                                for ( i = 0; i < predicates.length; i++ ) {
                                    predicate = predicates[i];
                                    if ( predicate ) {
                                        elem.options[ i ] = new Option( predicate.get("label"), predicate.get("url") );
                                    }
                                }
                            }

                            // Get field aggregations
                            getAdditionalFieldAggregations( field, select, wrapper, dataModelName, 1, 5 );

                        }
                    }
                }
            }
        }
    }
}

/**
 * Get field ad-hoc aggregations from Explore Manager.
 * @param field {object} Field object.
 * @param select {object} DOM element of the drop-down display.
 * @param wrapper {object} DOM element of the drop-down wrapper.
 * @param dataModelName {string} Data model name.
 * @param tryNumber {number} Number of times the function has been called.
 * @param maxTries {number} Maximum number of times the function will be called.
 */
function getAdditionalFieldAggregations( field, select, wrapper, dataModelName, tryNumber, maxTries ) {

    var input;
    var date2;
    var properties;
    var selected;
    var name;

    if ( field ) {
        var fieldName = field.name;
        var fieldType = field.type;
        var options = field.options;
        var aggType = 'count'; // Aggregation type is always count for Advanced Search
        var aggSort = '_key'; // Returned aggregations are sorted by their _key values
        var aggOrder = 'asc';  // Return aggregations in ascending sorting order. For descending order, change to "desc".

        if ( fieldName && fieldType && dataModelName ) {

            var aggregations;
            var url = getFieldAggregationURL( dataModelName, field, aggType, aggSort, aggOrder );

            if ( url ) {
                $.ajax({
                    url: url,
                    data: {},
                    dataType: 'json'
                })
                    .done( function( aggdata ) {

                        if ( aggdata ) {
                            aggregations = aggdata.aggregations;
                        }
                        // Hide previously shown inputs
                        input = select.next();
                        date2 = input.find( '.additional-data-date-calendar-2');
                        date2.hide();

                        select.show();

                        // hide properties if they were shown before and the field is not nested
                        properties = wrapper.find('.additional-field-properties');
                        if ( properties ) {
                            properties.empty();
                            properties.hide();
                        }

                        // check if field model has options

                        if ( fieldType === "enumeration" ) {
                            if ( field.options && hasKeys( field.options ) ) {
                                options = field.options;
                            } else {
                                // show a text input for enumeration fields with no options
                                fieldType = "string";
                            }
                        }

                        // Show field inputs depending on the field type
                        initializeAdditionalFieldInputs( fieldType, wrapper, options, aggregations );

                        // Listen for change event for field predicates
                        select.change( function ( ) {

                            selected = $( this ).find( "option:selected" );
                            if ( selected ) {
                                name = selected.attr( "value" );
                                if ( name ) {

                                    input = $( this ).next();
                                    date2 = input.find( '.additional-data-date-calendar-2');
                                    if ( input && date2 ) {

                                        if ( name === "between" ) {

                                            date2.show();
                                            $( date2 ).find( '.additional-data-input-date-2' ).show();
                                            input.show();

                                        } else {
                                            date2.hide();
                                            $( date2 ).find( '.additional-data-input-date-2' ).hide();
                                        }
                                    }
                                }
                            }
                        });
                    })
                    .fail( function( jqXHR, textStatus, errorThrown ) {
                        console.log('[' + new Date() + '] Error occurred in getting ad-hoc aggregations for url ' + url + ':');
                        console.log(textStatus);
                        console.log(errorThrown);
                        if ( tryNumber <= maxTries ) {
                            getAdditionalFieldAggregations( field, select, wrapper, dataModelName, tryNumber + 1, maxTries );
                        } else {
                            initializeAdditionalFieldInputs( fieldType, wrapper, options, null );
                        }
                    });
            }
        }
    }
}

/**
 * Initialize field input element based on field type
 * @param type {string} Field type.
 * @param el {object} Field DOM element.
 * @param options {object|null} Available values for field of type enumeration and null otherwise.
 * @param aggregations {object} Field aggregations object.
 */
function initializeAdditionalFieldInputs( type, el, options, aggregations ) {

    var input;
    var date;
    var date2;
    var enumeration;
    var text;
    var buckets;

    // type is not an object
    if ( el && type && type.toString() !== "object" ) {
        input = $( el ).find( '.additional-data-input' );

        if ( input ) {
            text = input.find( '.additional-data-input-text' );
            date = input.find( '.additional-data-input-date' );
            date2 = input.find( '.additional-data-input-date-2' );
            enumeration = input.find( '.additional-data-input-enum' );

            if ( aggregations ) {

                for ( var key in aggregations ) {
                    if ( aggregations.hasOwnProperty( key )) {
                        var bucketsObj = aggregations[ key ];
                        if ( bucketsObj ) {
                            buckets = bucketsObj.buckets;
                        }
                    }
                }
            }

            if ( buckets && buckets.length > 0 && text && date ) {
                // Display aggregations from buckets
                text.hide();
                date.hide();
                showAggregationDropdown( enumeration, buckets );

            } else {
                if ( type === "date" && text && date && date2 && enumeration ) {

                    // show calendar and hide text and enum inputs
                    text.hide();
                    date.val( null );
                    date.attr('placeholder', 'MM/DD/YYYY (No values found)');
                    date2.val( null );
                    date2.attr('placeholder', 'MM/DD/YYYY (No values found)');

                    // create a date picker input
                    // date.datepicker({
                    //     forceParse: false,
                    //     autoclose: true,
                    //     todayHighlight: true,
                    //     toggleActive: true
                    // });

                    // create a second date picker input
                    // date2.datepicker({
                    //     forceParse: false,
                    //     autoclose: true,
                    //     todayHighlight: true,
                    //     toggleActive: true
                    // });

                    date.parent().show();
                    date.show();
                    enumeration.hide();
                } else if ( type === "enumeration" && text && date ) {
                    text.hide();
                    date.hide();
                    showEnumerationDropdown( enumeration, options );
                } else if ( text && date && enumeration ) {

                    // Show text input box
                    text.val(null);
                    text.attr('placeholder', 'No values found');
                    text.show();
                    date.hide();
                    enumeration.hide();
                }
            }
            input.show();
            el.show();

            // TODO - hide loading icon

        }

        // Set field filter if it is found in the URL
        if ( Backbone && Backbone.history ) {
            var filters = getFiltersStringFromURL( Backbone.history.getFragment() );
            if ( filters ) {
                setAdditionalAdvancedSearchFiltersValues( el, filters );
            }
        }
    }
}

/**
 * Populate field properties drop-down for nested field
 * @param field {object} - nested field model
 * @param select {array} - array with one value that contains field properties DOM element
 */
function initializeAdditionalFieldProperties( field, select ) {

    var type,
        properties,
        property,
        predicates,
        inputs,
        el,
        selected,
        name,
        i;

    if ( field ) {

        type = field.type;

        if ( type === "object" ) {

            properties = field.properties;

            if ( properties ) {
                // Dynamically add predicate options

                if ( select && select.length === 1 ) {
                    el = select[ 0 ];

                    if ( el && el.options ) {
                        // Reset available options
                        el.options.length = 0;

                        // Add - Select data field - option
                        el.options[0] = new Option( "- Select data field -", null );

                        // Add model fields
                        for ( i = 1; i < properties.length; i++ ) {
                            property = properties[ i ];
                            if ( property ) {
                                el.options[ i ] = new Option( property.label, property.name );
                            }
                        }

                    }

                    select.show();
                    predicates = select.next();
                    if ( predicates ) {
                        predicates.hide();
                        inputs = predicates.next();
                        if ( inputs ) {
                            inputs.hide();
                        }
                    }

                    // Listen for change event for field properties
                    select.change( function ( ) {
                        selected = $(this).find("option:selected");
                        if (selected) {
                            name = selected.attr("value");
                            if (name) {
                                initializeAdditionalNestedFieldPredicates( field, name, this );
                            }
                        }
                    });
                }

            }
        }
    }
}

/**
 * Initialize predicate drop-down for an additional nested field
 * @param field {object} - field model
 * @param name {string} - field name
 * @param el {object} - additional field element
 */
function initializeAdditionalNestedFieldPredicates( field, name, el ) {

    var properties,
        nestedField,
        type;

    if ( field ) {
        properties = field.properties;
        nestedField = getFieldProperty( properties, name );

        if ( nestedField ) {
            type = nestedField.type;
            populateAdditionalFieldPredicates( nestedField, type, $( el ).parent().prev(), true );
        }
    }

}

/**
 * Attach a listener to each remove field button
 */
function initializeFieldRemoveEvent() {
    // remove additional field element from the DOM
    $( '.remove-field' ).on( 'click', function( e ) {
        var button,
            id,
            index,
            elementId,
            element,
            list,
            fields,
            fieldToRemove;

        e.preventDefault();

        if ( e ) {
            button = e.currentTarget;
            if ( button ) {
                id = $( button ).attr("id");
                if ( id && id.length ) {
                    index = id[ id.length - 1 ];
                    if ( index ) {
                        elementId = "additional-field-" + index;
                        element = $( '#'+ elementId );
                        list = $('#additional-conditional');
                        if ( list && list.length === 1 && element && element.length === 1 ) {
                            fields = list[0];
                            fieldToRemove = element[0];
                            if ( fields && fields.hasChildNodes() ) {
                                fields.removeChild( fieldToRemove );
                            }
                        }
                    }
                }
            }
        }
    });
}

/**
 * Save the URL and site origin that linked to the current page.
 */
function saveReferrerIntoGlobal() {

    var doc;
    var page;

    // Get the web page's content
    doc = $( document );
    if ( doc && doc.length === 1 ) {
        page = doc[0];
        if ( page ) {
            if ( page.referrer && page.referrer.length > 0 ) {
                // Save the page referrer into the global stage
                if ( App && App.globalState ) {
                    App.globalState.referrer = page.referrer;

                }
            }
            if ( page.location ) {
                if ( page.location.origin ) {
                    App.globalState.origin = page.location.origin;
                }
                if ( page.location.pathname ) {
                    App.globalState.pathname = page.location.pathname;
                }
            }
        }
    }
}

/**
 * Append a route at the end of the referrer page and send it back; do not display search results on Advanced Search page.
 */
function sendAdvancedSearchData(  ) {

    // Do not perform Advanced Search and do not display the results
    // Send the route back to the referrer with updated optional parameters
    // based on current filters, plus the parameters being sent by the referrer.

    var currentParams;
    var currentParamsObj = {};
    var route;
    var newParams;
    var newParamsObj;

    if ( Backbone && Backbone.history ) {
        currentParams = getURLParameters( Backbone.history.fragment );
    }
    if ( currentParams ) {
        var currentParamsArray = currentParams.split( '&' );
        currentParamsObj = convertParamsToObject( currentParamsArray );
    }


    if ( App.globalState ) {
        route = getURLBaseRoute( App.globalState.referrer );
        newParams = getRouteFromVariables( '', App.globalState.query, App.globalState.currentFilters );
        newParams = getURLParameters( newParams );
    }

    // Substitute new parameters into the current parameters
    if ( newParams ) {
        var newParamsArray = newParams.split( '&' );
        newParamsObj = convertParamsToObject( newParamsArray );
    }
    console.log(newParamsObj, "This is an Object")
    // Update the current parameters object with the new keys
    // Existing keys will be updated, and news keys will be created
    for ( var key in newParamsObj ) {
        if ( newParamsObj.hasOwnProperty( key ) && currentParamsObj ) {
            currentParamsObj[ key ] = newParamsObj[ key ];
        }
    }

    // Convert the current parameters object into a string
    // Add a separator "&" between each parameter
    var updatedParams = '';
    if ( currentParamsObj ) {
        updatedParams += _.map( currentParamsObj, function ( value, key ) {
            if ( value && key ) {
                return `${key}.keyword` + '=' + value;
            }
        }).join('&');
    }

    if ( route ) {
        if ( updatedParams ) {
            route += '?' + updatedParams;
        }
        window.location.href = route;
    }
}

/**
 * Convert parameters array into an object.
 * @param array {[string]} Array of string parameters: [ "param1=value1", "param2=value2", ...]
 * @returns {{}} Object containing parameters and their values: { param1: value1, param2: value2, ... }
 */
function convertParamsToObject( array ) {
    var object = {};
    if ( array ) {
        for ( var i = 0; i < array.length; i++ ) {
            var param = array[ i ];
            if ( param ) {
                var paramArray = param.split('=');
                if ( paramArray && paramArray.length === 2 ) {
                    var paramName = paramArray[ 0 ];
                    var paramValue = paramArray[ 1 ];

                    if ( paramName ) {
                        object[ paramName ] = paramValue;
                    }
                }
            }
        }
    }
    return object;
}